<template>
  <DashboardTemplate :navMenu="true" class="profile-detail">
    <div class="flex-display js-between ai-center pd-b-3 disabled-on-print mobile-display-name-list">
      <h3 class="name mg-y-less text-font-24 text-break-word">
        ข้อมูลส่วนตัว {{ getPrefixLabel(personal.prefix) }}{{ personal.nameTh }} {{ personal.lastNameTh }}
      </h3>
      <div class="print">
        <div @click="print" class="circle-print color-bg-primary-light">
          <i class="fas fa-print"></i>
        </div>
      </div>
    </div>

    <div class="show-only">
      <div class=" flex-display js-center ai-center pd-b-3">
        <div class="box-image square ">
          <avatar
            v-if="personal.profileImg || profileFrom"
            :rounded="false"
            :username="personal.nameTh"
            :class="{
              facebook: from == 'faceBook' && personal.profileImg == '',
            }"
            :src="
              personal.profileImg
                ? `${urlImage}${userId}/${personal.profileImg}`
                : from == 'faceBook' && personal.profileImg == ''
                ? `https://graph.facebook.com/${profileFrom}/picture?type=large`
                : `${profileFrom}`
            "
            :size="160"
            class="set-img"
          ></avatar>
        </div>
      </div>
    </div>

    <div v-loading="loading" class=" pd-b-print-less">
      <div>
        <div class="pd-y-3 disabled-on-print out-box-image pd-x-4">
          <el-upload
            action="#"
            class="box-image-upload-profile"
            ref="upload"
            list-type="picture-card"
            :auto-upload="false"
            :disabled="showEdit == 'false'"
            :on-change="uploadImage"
          >
            <div class="preview">
              <avatar
                v-if="personal.profileImg || profileFrom"
                :rounded="false"
                :username="personal.nameTh"
                :class="{
                  facebook: from == 'faceBook' && personal.profileImg == '',
                }"
                :src="
                  personal.profileImg
                    ? `${urlImage}${userId}/${personal.profileImg}`
                    : from == 'faceBook' && personal.profileImg == ''
                    ? `https://graph.facebook.com/${profileFrom}/picture?type=large`
                    : `${profileFrom}`
                "
                :size="160"
                class="set-img"
              ></avatar>
              <avatar
                v-else
                :rounded="false"
                :username="personal.nameTh"
                :src="``"
                :size="160"
                class="set-img"
              ></avatar>
              <span v-if="showEdit == 'true'" class="icon">
                <i class="fas fa-1x fa-camera"></i>
              </span>
            </div>

            <!-- <div class="preview">
              <avatar
                v-if="personal.profileImg != ''"
                :rounded="false"
                :username="personal.nameTh"
                :src="`${urlImage}${userId}/${personal.profileImg}`"
                :size="160"
                class="set-img"
              ></avatar>
              <span v-if="showEdit == 'true'" class="icon">
                <i class="fas fa-1x fa-camera"></i>
              </span>
            </div> -->
          </el-upload>
        </div>
        <div class="view-box">
          <div class="pd-b-2 pd-b-print-3">
            <div class="flex-display js-between ai-center border-b mg-b-3">
              <h4 class="mg-y-4 text-font-18">ข้อมูลส่วนบุคคล</h4>
              <a
                v-if="showEdit == 'true' && !showInputPersonal"
                @click="showInputPersonal = true"
                class="text-font-12 color-primary-light disabled-on-print"
              >
                <i class="fas fa-pen"></i> แก้ไขข้อมูล
              </a>
            </div>
            <ProfilePersonalInfoForm
              v-if="showInputPersonal"
              from="profile"
              :value="personal"
              @setFormStep="(data) => saveProfile(data, 'personal')"
            />
            <ProfilePersonalInfoView
              v-else
              :prefix="personal.prefix"
              :nameTh="personal.nameTh"
              :lastNameTh="personal.lastNameTh"
              :nameEn="personal.nameEn"
              :lastNameEn="personal.lastNameEn"
              :phoneNumber="personal.phoneNumberObj.formatNational"
              :idCard="personal.idCard"
              :birthDay="personal.birthDay"
              :position="personal.position"
              :address="personal.address"
              :subDistrict="personal.subDistrict"
              :district="personal.district"
              :province="personal.province"
              :postcode="personal.postcode"
            />
          </div>
          <div class="pd-b-2 pd-b-print-less">
            <div class="flex-display js-between ai-center border-b mg-b-3">
              <h4 class="mg-y-4 text-font-18">ข้อมูลองค์กร</h4>
              <a
                v-if="showEdit == 'true' && !showInputCompany"
                @click="showInputCompany = true"
                class="text-font-12 color-primary-light disabled-on-print"
              >
                <i class="fas fa-pen"></i> แก้ไขข้อมูล
              </a>
            </div>

            <ProfileCompanyForm
              v-if="showInputCompany"
              from="profile"
              :value="company"
              @setFormStep="(data) => saveProfile(data, 'company')"
            />
            <ProfileCompanyView
              v-else
              from="profile"
              :agency="company.agency"
              :agencyType="company.agencyType"
              :etc="company.etc"
              :address="company.address"
              :subDistrict="company.subDistrict"
              :district="company.district"
              :province="company.province"
              :postcode="company.postcode"
            />
          </div>
        </div>
      </div>
    </div>
  </DashboardTemplate>
</template>

<script>
import DashboardTemplate from "@/template/DashboardTemplate";
import ProfilePersonalInfoView from "@/components/profile/ProfilePersonalInfoView";
import ProfileCompanyView from "@/components/profile/ProfileCompanyView";
import Avatar from "vue-avatar";
import ProfilePersonalInfoForm from "@/components/profile/ProfilePersonalInfoForm";
import ProfileCompanyForm from "@/components/profile/ProfileCompanyForm";
import { HTTP } from "@/service/axios.js";

export default {
  components: {
    DashboardTemplate,
    ProfilePersonalInfoView,
    ProfileCompanyView,
    Avatar,
    ProfilePersonalInfoForm,
    ProfileCompanyForm,
  },
  props: {
    routeParams: {
      type: Object,
      default: null,
    },
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    prefixList() {
      return this.$store.state.prefixList;
    },
  },
  data() {
    return {
      showEdit: true,
      profileFrom:'',
      from:'',
      personal: {
        profileImg: "",
        prefix: null,
        nameTh: "",
        lastNameTh: "",
        nameEn: "",
        lastNameEn: "",
        idCard: "",
        birthDay: "",
        position: "",
        address: "",
        subDistrict: "",
        district: "",
        province: "",
        postcode: "",
        phoneNumberObj: {
          countryCode: "",
          formatNational: "",
          numberValid: true,
        },
      },
      company: {
        agency: "",
        agencyType: null,
        etc: "",
        address: "",
        subDistrict: "",
        district: "",
        province: "",
        postcode: "",
      },
      showInputPersonal: false,
      showInputCompany: false,
      userId: "",
      urlImage: process.env.VUE_APP_BASE_URL_IMAGE,
      loading: true,
    };
  },
  mounted() {
    this.setParams();
    this.fetchStudentsById();
  },
  methods: {
    uploadImage(file) {
      this.loading = true;

      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };

      let formData = new FormData();

      formData.append("userId", this.userId);
      formData.append("img", file.raw);
      formData.append("delFile", this.personal.profileImg);

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post(`update/profile/img`, formData, config)
        .then((res) => {
          if (res.data.success) {
            this.fetchStudentsById();
          } else {
            this.alertFailError();
          }
        })
        .catch((e) => {
          this.alertCatchError(e);
          console.log("uploadImage error", e);
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 500);
        });
    },
    setParams() {
      if (this.routeParams != null) {
        if (typeof this.routeParams.edit != "undefined") {
          this.showEdit = this.routeParams.edit;
          this.userId = this.routeParams.userId;
        }
      }
    },
    fetchStudentsById() {
      let obj = {
        _id: this.userId,
      };

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post(`get/student`, obj)
        .then((res) => {
          if (res.data.success) {
            this.profileFrom = typeof res.data.obj.profileFrom !== 'undefined' && res.data.obj.profileFrom?res.data.obj.profileFrom:''
            this.from = typeof res.data.obj.from !== 'undefined' && res.data.obj.from?res.data.obj.from:''
            
            this.personal = {
              profileImg: res.data.obj.profileImg,
              prefix: res.data.obj.titleName,
              nameTh: res.data.obj.nameTH,
              lastNameTh: res.data.obj.surnameTH,
              nameEn: res.data.obj.nameEN,
              lastNameEn: res.data.obj.surnameEN,
              idCard: res.data.obj.identification,
              birthDay:
                this.showEdit == true
                  ? new Date(res.data.obj.birthday)
                  : res.data.obj.birthday,
              position: res.data.obj.position,
              address: res.data.obj.address,
              subDistrict: res.data.obj.subdistrict,
              district: res.data.obj.district,
              province: res.data.obj.province,
              postcode: res.data.obj.postcode,
              phoneNumberObj: {
                countryCode: res.data.obj.countryCode,
                formatNational: res.data.obj.mobilephone,
                numberValid: true,
              },
            };

            this.company = {
              agency: res.data.obj.institution.name,
              agencyType: res.data.obj.institution.type,
              etc:
                typeof res.data.obj.institution.etc != "undefined"
                  ? res.data.obj.institution.etc
                  : "",
              address: res.data.obj.institution.address,
              subDistrict:
                typeof res.data.obj.institution.subdistrict != "undefined"
                  ? res.data.obj.institution.subdistrict
                  : "",
              district: res.data.obj.institution.district,
              province: res.data.obj.institution.province,
              postcode: res.data.obj.institution.postcode,
            };
          } else {
            this.alertFailError();
          }
        })
        .catch((e) => {
          this.alertCatchError(e);
          console.log("fetchStudentsById error", e);
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 500);
        });
    },
    getPrefixLabel(id) {
      let filter = this.prefixList.filter((filter) => filter.id == id);
      if (filter.length > 0) {
        return filter[0].label;
      }
    },
    saveProfile(data, type) {
      this.loading = true;

      let obj = {
        _id: this.userId,
        titleName: type == "personal" ? data.prefix : this.personal.prefix,
        nameTH: type == "personal" ? data.nameTh : this.personal.nameTh,
        surnameTH:
          type == "personal" ? data.lastNameTh : this.personal.lastNameTh,
        nameEN: type == "personal" ? data.nameEn : this.personal.nameEn,
        surnameEN:
          type == "personal" ? data.lastNameEn : this.personal.lastNameEn,
        mobilephone:
          type == "personal"
            ? data.phoneNumber
            : this.personal.phoneNumberObj.formatNational,
        identification: type == "personal" ? data.idCard : this.personal.idCard,
        birthday: type == "personal" ? data.birthDay : this.personal.birthDay,
        position: type == "personal" ? data.position : this.personal.position,
        address: type == "personal" ? data.address : this.personal.address,
        postcode: type == "personal" ? data.postcode : this.personal.postcode,
        subdistrict:
          type == "personal" ? data.subDistrict : this.personal.subDistrict,
        district: type == "personal" ? data.district : this.personal.district,
        province: type == "personal" ? data.province : this.personal.province,
        institution: {
          name: type == "company" ? data.agency : this.company.agency,
          type: type == "company" ? data.agencyType : this.company.agencyType,
          etc: type == "company" ? data.etc : this.company.etc,
          address: type == "company" ? data.address : this.company.address,
          postcode: type == "company" ? data.postcode : this.company.postcode,
          subdistrict:
            type == "company" ? data.subDistrict : this.company.subDistrict,
          district: type == "company" ? data.district : this.company.district,
          province: type == "company" ? data.province : this.company.province,
        },
      };

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.put(`student`, obj)
        .then((res) => {
          if (res.data.success) {
            this.showInputPersonal = false;
            this.showInputCompany = false;
            this.fetchStudentsById();
            this.$message({
              message: 'แก้ไขสำเร็จแล้ว',
              type: 'success'
            });
          } else {
            this.alertFailError();
          }
        })
        .catch((e) => {
          this.alertCatchError(e);
          console.log("saveProfile error", e);
        });
    },
    print() {
      window.print();
    },
  },
};
</script>

<style scoped>
.view-box {
  padding-right: 20px;
  padding-left: 20px;
}
@media (max-width: 1199.98px) {
  .view-box {
    padding: 0 15px;
  }
}
@media (max-width: 991.98px) {
  .view-box {
    padding: 0 15px;
  }
}
.circle-print {
  width: 45px;
  height: 45px;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 18px;
  cursor: pointer;
}
</style>
